module.exports = __webpack_public_path__ + "media/base/hamburger_icon-dd46679f.svg";